import img01 from "../../../assets/images/myanwan/partner-01.png";
import img02 from "../../../assets/images/myanwan/partner-02.png";
import img03 from "../../../assets/images/myanwan/partner-03.png";
import img04 from "../../../assets/images/myanwan/partner-04.png";
import img05 from "../../../assets/images/myanwan/partner-05.png";
import img06 from "../../../assets/images/myanwan/partner-06.png";
import img07 from "../../../assets/images/myanwan/partner-07.png";
// import img08 from "../../../assets/images/myanwan/partner-07.png";
import img09 from "../../../assets/images/myanwan/partner-09.png";
import img10 from "../../../assets/images/myanwan/partner-010.png";
import img11 from "../../../assets/images/myanwan/partner-011.png";
import img12 from "../../../assets/images/myanwan/partner-012.png";
import img13 from "../../../assets/images/myanwan/partner-013.png";

import b01 from "../../../assets/images/myanwan/b-01.png";
import b02 from "../../../assets/images/myanwan/b-02.png";
import b03 from "../../../assets/images/myanwan/b-03.png";
import b04 from "../../../assets/images/myanwan/b-04.png";
import b05 from "../../../assets/images/myanwan/b-05.png";
import b06 from "../../../assets/images/myanwan/b-06.png";
import b07 from "../../../assets/images/myanwan/b-08.png";
import b08 from "../../../assets/images/myanwan/b-09.png";
import b09 from "../../../assets/images/myanwan/b-010.png";
import b010 from "../../../assets/images/myanwan/b-07.png";
import b011 from "../../../assets/images/myanwan/b-011.png";
import b012 from "../../../assets/images/myanwan/b-012.png";

export const partners = [
  img01,
  img02,
  img03,
  img04,
  img05,
  img06,
  img07,
  img09,
  img10,
  img11,
  img12,
  img13,
];

export const businesses = [
  {
    id: 1,
    name: "Ginga Recycle Arts & Crafts",
    logo: b01,
    link: "https://ginga.myanwen.shop/",
  },
  {
    id: 2,
    name: "Just Bakery Distribution",
    logo: b02,
    link: "https://justcoffee.myanwen.shop/",
  },
  {
    id: 3,
    name: "KanBawZa လက်ဖက်",
    logo: b03,
    link: "https://kanbawza.myanwen.shop/",
  },
  {
    id: 4,
    name: "Lokal Zaytann - ဒေသစျေးတန်း",
    logo: b04,
    link: "https://lokalzay.myanwen.shop/",
  },
  {
    id: 5,
    name: "Math Stars Academy ",
    logo: b05,
    link: "http://msa.myanwen.shop/",
  },
  {
    id: 6,
    name: "Mudra",
    logo: b06,
    link: "https://mudra.myanwen.shop/",
  },
  {
    id: 7,
    name: "Nature Farm",
    logo: b07,
    link: "https://nfarm.myanwen.shop/",
  },
  {
    id: 8,
    name: "Pu TuTuu Education Center",
    logo: b08,
    link: "https://pututuu.myanwen.shop/",
  },
  {
    id: 9,
    name: "S & Q Shopping",
    logo: b09,
    link: "https://sqmm.myanwen.shop/",
  },
  {
    id: 10,
    name: "စ​လေ​ရှေ့​ဆောင်",
    logo: b010,
    link: "https://salay.myanwen.shop/",
  },
  {
    id: 11,
    name: "Spring Corner",
    logo: b011,
    link: "http://springcorner.myanwen.shop/",
  },
  {
    id: 12,
    name: "ကံစိန်",
    logo: b012,
    link: "https://kansein.myanwen.shop/",
  },
];
